var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13 3.008A2 2 0 0 1 6.867 2h10.267a2 2 0 0 1 1.737 1.008l1.143 2c.648 1.134.048 2.503-1.09 2.887.004.082.003.164-.003.247l-.857 12A2 2 0 0 1 16.07 22H7.932a2 2 0 0 1-1.995-1.858l-.857-12a2.025 2.025 0 0 1-.003-.247c-1.138-.384-1.738-1.753-1.09-2.887l1.143-2zM7.074 8l.215 3h9.423l.215-3H7.074zm.643 9 .215 3h8.137l.215-3H7.717zm10.56-11-1.143-2H6.867L5.724 6h12.553z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoffee);
export default __webpack_public_path__ + "static/media/icon_coffee.ee35ca9f32be8e62e5317f0664055f72.svg";
export { ForwardRef as ReactComponent };